import { Styles } from '@contently/toolkit';

const { colors } = Styles;
const classNamePrefix = 'selector';
const dropdownIndicatorStyles = {
  color: colors.grey.altLight,
  maxHeight: '40px',
  padding: '0 10px'
};
const menuPlacement = 'auto';

const componentStyles = (error, isTouched) => {
  const showError = error && isTouched;
  const borderColor = (isFocused) => {
    if (showError) return colors.red.primary;

    return isFocused ? colors.blue.primary : colors.grey.secondaryDark;
  };
  const backgroundColor = (isFocused, isSelected) => {
    if (isFocused) return colors.blue.secondaryLight;

    return isSelected ? colors.blue.secondarycolors : colors.white;
  };

  return {
    control: (styles, { isFocused }) => ({
      ...styles,
      boxShadow: 'none',
      borderRadius: '3px',
      borderColor: borderColor(isFocused),
      minHeight: '40px',
      ':hover': {
        borderColor: borderColor(isFocused)
      }
    }),
    dropdownIndicator: styles => ({
      ...styles,
      padding: '0'
    }),
    input: styles => ({
      ...styles,
      minHeight: 'auto',
      input: {
        minHeight: '0'
      }
    }),
    menu: styles => ({
      ...styles,
      margin: '0',
      zIndex: '350'
    }),
    menuList: styles => ({
      ...styles,
      padding: '0'
    }),
    group: styles => ({
      ...styles,
      padding: '0'
    }),
    groupHeading: styles => ({
      ...styles,
      backgroundColor: colors.grey.secondary,
      margin: '0',
      padding: '4px 8px',
      fontSize: '12px',
      fontWeight: '400',
      color: colors.black
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: backgroundColor(isFocused, isSelected),
      color: colors.black,
      ':active': {
        backgroundColor: colors.blue.secondaryLight
      }
    }),
    multiValue: styles => ({
      ...styles,
      backgroundColor: colors.white,
      border: `1px solid ${colors.grey.secondaryDark}`
    }),
    multiValueLabel: styles => ({
      ...styles,
      fontSize: '14px'
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: colors.grey.secondaryDark,
      ':hover': {
        backgroundColor: colors.white,
        color: colors.black
      }
    })
  };
};

const theme = existingTheme => ({
  ...existingTheme,
  colors: {
    ...existingTheme.colors,
    primary: colors.blue.secondaryDark
  }
});

export {
  classNamePrefix, componentStyles, theme, dropdownIndicatorStyles, menuPlacement
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/enhanced_select/styles.js